
export default {
//adminPortalUrl: 'http://localhost:8081/',

 adminPortalUrl: 'https://portal.Kotina.com/',

encryptkey:'4288943859999624',
encryptiv:'8935076607156689',
};
